import { render, staticRenderFns } from "./AttachPackage.vue?vue&type=template&id=31c685da&v-on-clickaway=cancel&"
import script from "./AttachPackage.vue?vue&type=script&lang=ts&"
export * from "./AttachPackage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports